import { createSlice } from '@reduxjs/toolkit';

import { initialState, reviewAdapter } from './review.state';
import { reviewListReducers } from './actions';

export const review = createSlice({
  name: 'review',
  initialState: reviewAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    reviewListReducers(builder);
  },
});

export const reviewReducer = review.reducer;
